import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=15d1bf84&scoped=true"
import script from "./Details.ts?vue&type=script&lang=ts&external"
export * from "./Details.ts?vue&type=script&lang=ts&external"
import style0 from "./Details.vue?vue&type=style&index=0&id=15d1bf84&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d1bf84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15d1bf84')) {
      api.createRecord('15d1bf84', component.options)
    } else {
      api.reload('15d1bf84', component.options)
    }
    module.hot.accept("./Details.vue?vue&type=template&id=15d1bf84&scoped=true", function () {
      api.rerender('15d1bf84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/AtrContracts/pages/Details/Details.vue"
export default component.exports